import { Component, Input } from '@angular/core';

@Component({
    selector: 'jhi-next-button',
    templateUrl: './next-button.component.html'
})
export class NextButtonComponent {
    isLoading: boolean;
    isDisabled: boolean;

    @Input() clickHandler: Function;
    @Input() label: string;

    constructor() {}

    onClickButton() {
        this.disableButton();

        let observable = this.clickHandler();
        if (observable) {
            observable.subscribe(
                () => this.enableButton(),
                () => this.enableButton()
            );
        } else {
            this.enableButton();
        }
    }

    disableButton() {
        this.isDisabled = true;
        this.isLoading = true;
    }

    enableButton() {
        this.isDisabled = false;
        this.isLoading = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/button/next-button/next-button.component.ts